(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jp-cart-herbal-addon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jp-cart-herbal-addon')) {
    let activeSubmission = null;
    let uncertainVariant = null;
    let uncertainContext = null;
    const savedByContext = new Map();
    const removedByContext = new Set();
    const contextOf = (node) => node.dataset.context || 'main';
    const findSlot = (root, context) => [...root.querySelectorAll('.jp-addon-slot')].find((node) => contextOf(node) === context);
    const findCard = (context) => [...document.querySelectorAll('jp-cart-herbal-addon')].find((node) => contextOf(node) === context);
    const sectionURL = () => new URL(window.location.pathname, window.location.origin);
    const cartParent = (node) => contextOf(node) === 'drawer' ? node.closest('cart-drawer') : node.closest('cart-items');
    const blockUncertainCards = () => document.querySelectorAll('jp-cart-herbal-addon').forEach((node) => {
      if (node.dataset.variantId !== uncertainVariant || !node.strings) return;
      if (contextOf(node) === uncertainContext) node.showError(node.strings.uncertain, true);
      node.querySelector('button')?.setAttribute('disabled', '');
    });
    const cartRegions = '#main-cart-items, #CartDrawer-CartItems, #main-cart-footer, cart-drawer .drawer-footer';
    const checkoutControls = '#main-cart-footer [name="checkout"], #CartDrawer-Checkout, #CartDrawer-ViewCart';
    const restoreAttribute = (node, name, value) => {
      if (value === null) node.removeAttribute(name);
      else node.setAttribute(name, value);
    };
    const lockCartControls = () => {
      if (!activeSubmission) return;
      const { regions, controls } = activeSubmission;
      document.querySelectorAll(cartRegions).forEach((node) => {
        if (!regions.has(node)) regions.set(node, { inert: node.getAttribute('inert'), busy: node.getAttribute('aria-busy') });
        node.setAttribute('inert', '');
        node.setAttribute('aria-busy', 'true');
      });
      const nodes = [...document.querySelectorAll(checkoutControls + ', jp-cart-herbal-addon button')];
      document.querySelectorAll(cartRegions).forEach((region) => nodes.push(...region.querySelectorAll('button, input, select, textarea, a')));
      nodes.forEach((node) => {
        if (!controls.has(node)) controls.set(node, { disabled: 'disabled' in node ? node.disabled : null, ariaDisabled: node.getAttribute('aria-disabled'), tabIndex: node.getAttribute('tabindex') });
        if ('disabled' in node) node.disabled = true;
        node.setAttribute('aria-disabled', 'true');
        node.setAttribute('tabindex', '-1');
      });
      document.querySelectorAll('jp-cart-herbal-addon').forEach((node) => {
        node.pending = true;
        node.setAttribute('aria-busy', 'true');
      });
    };
    const releaseCartControls = (submission) => {
      submission.observer.disconnect();
      submission.events.forEach((name) => document.removeEventListener(name, submission.blockInteraction, true));
      submission.regions.forEach(({ inert, busy }, node) => {
        if (!node.isConnected) return;
        restoreAttribute(node, 'inert', inert);
        restoreAttribute(node, 'aria-busy', busy);
      });
      submission.controls.forEach(({ disabled, ariaDisabled, tabIndex }, node) => {
        if (!node.isConnected) return;
        if (disabled !== null) node.disabled = disabled;
        restoreAttribute(node, 'aria-disabled', ariaDisabled);
        restoreAttribute(node, 'tabindex', tabIndex);
      });
      activeSubmission = null;
      document.querySelectorAll('terms-checkbox').forEach((node) => {
        node.setCheckbox?.();
        node.restoreCheckboxState?.();
      });
      document.querySelectorAll('jp-cart-herbal-addon').forEach((node) => {
        node.pending = false;
        node.removeAttribute('aria-busy');
      });
      document.querySelectorAll('jp-cart-addon-slot').forEach((node) => node.syncEmptyState());
    };
    customElements.define('jp-cart-addon-slot', class extends HTMLElement {
      connectedCallback() {
        this.cartItems = cartParent(this);
        if (!this.cartItems) return;
        this.observer = new MutationObserver((records) => {
          if (this.wasEmpty === false && !this.cartItems.classList.contains('is-empty') && records.some((record) => record.oldValue?.split(/\s+/).includes('is-empty'))) this.clearCard();
          this.syncEmptyState();
        });
        this.observer.observe(this.cartItems, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.jpHerbalAddon || !this.isConnected) return;
            if (this.refreshController && !this.querySelector('jp-cart-herbal-addon')) {
              this.refreshController.abort();
              this.refreshController = null;
            }
            this.syncEmptyState();
          });
        }
        this.syncEmptyState();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.unsubscribe?.();
        this.refreshController?.abort();
        if (this.cartItems?.classList.contains('is-empty')) this.clearCard();
      }
      clearCard() {
        if (activeSubmission) activeSubmission.cartChanged = true;
        savedByContext.delete(contextOf(this));
        removedByContext.delete(contextOf(this));
        this.refreshController?.abort();
        this.refreshController = null;
        this.hidden = true;
        const card = this.querySelector('jp-cart-herbal-addon');
        card?.refreshController?.abort();
        if (card) {
          card.dataset.eligible = 'false';
          card.dataset.saved = '0';
          card.querySelector('button')?.setAttribute('disabled', '');
          this.replaceChildren();
        }
      }
      syncEmptyState() {
        if (!this.cartItems || !this.isConnected) return;
        const empty = this.cartItems.classList.contains('is-empty');
        this.cartItems.closest('.cart__items-wrapper')?.classList.toggle('empty-cart', empty);
        this.wasEmpty = empty;
        if (empty) {
          this.clearCard();
        } else if (!this.querySelector('jp-cart-herbal-addon')) {
          this.hidden = true;
          if (activeSubmission) activeSubmission.cartChanged = true;
          else if (!this.refreshController) this.refreshCard();
        } else {
          this.hidden = false;
        }
      }
      async refreshCard() {
        if (!this.isConnected || activeSubmission || this.cartItems.classList.contains('is-empty')) return;
        const controller = new AbortController();
        this.refreshController = controller;
        try {
          const url = sectionURL();
          url.searchParams.set('sections', this.dataset.sectionId);
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
          if (!response.ok) throw new Error('Cart section unavailable');
          const sections = await response.json();
          const html = sections[this.dataset.sectionId];
          if (typeof html !== 'string') throw new Error('Cart section unavailable');
          const sourceDocument = new DOMParser().parseFromString(html, 'text/html');
          const sourceSlot = findSlot(sourceDocument, contextOf(this));
          const sourceItems = sourceSlot && cartParent(sourceSlot);
          if (!sourceSlot || !sourceItems) throw new Error('Cart section unavailable');
          if (!this.isConnected || this.refreshController !== controller || controller.signal.aborted || activeSubmission || this.cartItems.classList.contains('is-empty')) return;
          if (sourceItems.classList.contains('is-empty') || !sourceSlot.querySelector('jp-cart-herbal-addon')) {
            this.replaceChildren();
            this.hidden = true;
            return;
          }
          this.innerHTML = sourceSlot.innerHTML;
          this.hidden = false;
        } catch (error) {
          if (!controller.signal.aborted && this.isConnected) this.hidden = true;
        } finally {
          if (this.refreshController === controller) this.refreshController = null;
        }
      }
    });
    customElements.define('jp-cart-herbal-addon', class extends HTMLElement {
      connectedCallback() {
        this.strings = JSON.parse(this.querySelector('[data-jp-addon-strings]').textContent);
        if (this.dataset.added !== 'true' || Number(this.dataset.saved) > 0) removedByContext.delete(contextOf(this));
        else if (savedByContext.get(contextOf(this)) > 0) removedByContext.add(contextOf(this));
        if (removedByContext.has(contextOf(this))) {
          const notice = this.querySelector('.jp-cart-addon__notice');
          notice.textContent = this.strings.removed;
          notice.hidden = false;
        }
        savedByContext.set(contextOf(this), Number(this.dataset.saved));
        this.pending = Boolean(activeSubmission);
        this.form = this.querySelector('form');
        this.handleSubmit = this.onSubmit.bind(this);
        this.form?.addEventListener('submit', this.handleSubmit);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.jpHerbalAddon || !this.isConnected) return;
            if (activeSubmission) activeSubmission.cartChanged = true;
            else this.refreshCard();
          });
        }
        if (activeSubmission) lockCartControls();
        if (this.dataset.variantId === uncertainVariant) blockUncertainCards();
      }
      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.handleSubmit);
        this.unsubscribe?.();
        this.refreshController?.abort();
      }
      showError(message, uncertain = false) {
        const node = this.querySelector('.jp-cart-addon__error');
        node.textContent = message;
        node.hidden = false;
        this.querySelector('.jp-cart-addon__refresh').hidden = !uncertain;
      }
      getSections() {
        const items = document.getElementById('main-cart-items');
        const footer = document.getElementById('main-cart-footer');
        const mainSection = items?.dataset.id || (contextOf(this) === 'main' ? this.dataset.sectionId : null);
        return [...new Set([mainSection, footer?.dataset.id, 'cart-icon-bubble', items && 'cart-live-region-text', 'cart-drawer'].filter(Boolean))];
      }
      isEligible(cart) {
        const variants = this.dataset.qualifyingVariantIds.split(',');
        return cart.items.some((item) => variants.includes(String(item.variant_id)));
      }
      async readCart() {
        const response = await fetch(this.dataset.cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(this.strings.error);
        return response.json();
      }
      hasAddon(cart) {
        return cart.items.some((item) => String(item.variant_id) === this.dataset.variantId && !item.selling_plan_allocation);
      }
      async fetchSections() {
        const url = sectionURL();
        url.searchParams.set('sections', this.getSections().join(','));
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) throw new Error(this.strings.error);
        return response.json();
      }
      applySections(sections, announce = false) {
        const parser = new DOMParser();
        const context = contextOf(this);
        const targetItems = document.querySelector('cart-items');
        const items = document.getElementById('main-cart-items');
        const footer = document.getElementById('main-cart-footer');
        const footerInput = footer?.querySelector('.custom-discount-form input[name="discount"]');
        const footerUI = { value: footerInput?.value, open: footerInput?.closest('details')?.open };
        let sourceItems, sourceContent, sourceSlot, sourceFooter;
        if (targetItems && items) {
          const sectionId = items.dataset.id || (context === 'main' ? this.dataset.sectionId : findCard('main')?.dataset.sectionId);
          const itemsHTML = sections[sectionId];
          const footerHTML = footer && sections[footer.dataset.id];
          if (typeof itemsHTML !== 'string' || typeof footerHTML !== 'string') throw new Error(this.strings.uncertain);
          sourceItems = parser.parseFromString(itemsHTML, 'text/html').querySelector('cart-items');
          sourceContent = sourceItems?.querySelector('#main-cart-items .js-contents');
          sourceSlot = sourceItems && findSlot(sourceItems, 'main');
          sourceFooter = parser.parseFromString(footerHTML, 'text/html').getElementById('main-cart-footer');
          if (!sourceContent || !sourceSlot || !items.querySelector('.js-contents') || !findSlot(targetItems, 'main') || !sourceFooter) throw new Error(this.strings.uncertain);
        }
        const drawer = document.querySelector('cart-drawer');
        if (drawer && sections['cart-drawer'] && sections['cart-icon-bubble']) {
          const sourceDrawer = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('cart-drawer');
          if (!sourceDrawer?.querySelector('#CartDrawer')) throw new Error(this.strings.uncertain);
          const input = drawer.querySelector('.custom-discount-form input[name="discount"]');
          const uiState = { value: input?.value, open: input?.closest('details')?.open };
          drawer.classList.toggle('is-empty', sourceDrawer.classList.contains('is-empty'));
          if (typeof drawer.renderContents === 'function') drawer.renderContents({ sections });
          else drawer.querySelector('#CartDrawer').innerHTML = sourceDrawer.querySelector('#CartDrawer').innerHTML;
          const nextInput = drawer.querySelector('.custom-discount-form input[name="discount"]');
          if (nextInput && typeof uiState.value === 'string') {
            nextInput.value = uiState.value;
            const details = nextInput.closest('details');
            if (details) details.open = Boolean(uiState.open);
          }
        } else if (context === 'drawer') {
          throw new Error(this.strings.uncertain);
        }
        if (sourceItems) {
          items.querySelector('.js-contents').innerHTML = sourceContent.innerHTML;
          targetItems.classList.toggle('is-empty', sourceItems.classList.contains('is-empty'));
          footer.className = sourceFooter.className;
          footer.innerHTML = sourceFooter.innerHTML;
          const nextFooterInput = footer.querySelector('.custom-discount-form input[name="discount"]');
          if (nextFooterInput && typeof footerUI.value === 'string') {
            nextFooterInput.value = footerUI.value;
            const details = nextFooterInput.closest('details');
            if (details) details.open = Boolean(footerUI.open);
          }
          const targetSlot = findSlot(targetItems, 'main');
          targetSlot.innerHTML = sourceSlot.innerHTML;
          targetSlot.hidden = sourceItems.classList.contains('is-empty') || !sourceSlot.querySelector('jp-cart-herbal-addon');
          if (typeof updateCartLayout === 'function') updateCartLayout();
          targetSlot.syncEmptyState?.();
        }
        if (typeof attachEventListeners === 'function') attachEventListeners();
        if (sections['cart-icon-bubble']) {
          const bubble = document.getElementById('cart-icon-bubble');
          const content = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (bubble && content) bubble.innerHTML = content.innerHTML;
        }
        const live = context === 'drawer' ? document.getElementById('CartDrawer-LiveRegionText') : document.getElementById('cart-live-region-text');
        if (announce) {
          if (live) { live.removeAttribute('aria-hidden'); live.textContent = this.strings.added; }
          findCard(context)?.querySelector('.jp-cart-addon__manage')?.focus({ preventScroll: true });
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', jpHerbalAddon: true });
      }
      async refreshCard() {
        if (activeSubmission) return;
        this.refreshController?.abort();
        const controller = new AbortController();
        this.refreshController = controller;
        const previousSaved = Number(this.dataset.saved);
        try {
          const url = sectionURL();
          url.searchParams.set('sections', this.dataset.sectionId);
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
          if (!response.ok) throw new Error(this.strings.error);
          const sections = await response.json();
          if (typeof sections[this.dataset.sectionId] !== 'string') throw new Error(this.strings.error);
          const sourceDocument = new DOMParser().parseFromString(sections[this.dataset.sectionId], 'text/html');
          const sourceSlot = findSlot(sourceDocument, contextOf(this));
          const source = sourceSlot?.querySelector('jp-cart-herbal-addon');
          if (!this.isConnected || controller.signal.aborted || activeSubmission) return;
          if (!source && sourceSlot && cartParent(sourceSlot)?.classList.contains('is-empty')) {
            const slot = this.closest('.jp-addon-slot');
            if (slot) { slot.hidden = true; slot.replaceChildren(); }
            else this.remove();
            return;
          }
          if (!source) throw new Error(this.strings.error);
          const removed = previousSaved > 0 && source.dataset.added === 'true' && Number(source.dataset.saved) === 0;
          if (removed) {
            const notice = source.querySelector('.jp-cart-addon__notice');
            notice.textContent = this.strings.removed;
            notice.hidden = false;
          }
          this.replaceWith(source);
        } catch (error) {
          if (error.name !== 'AbortError' && !controller.signal.aborted && !activeSubmission && this.isConnected) {
            this.showError(this.strings.error, true);
            const button = this.querySelector('button');
            if (button) button.disabled = true;
          }
        }
      }
      async onSubmit(event) {
        event.preventDefault();
        if (!this.isConnected || this.pending || activeSubmission || this.dataset.variantId === uncertainVariant || cartParent(this)?.classList.contains('is-empty') || this.closest('.jp-addon-slot')?.hidden) return;
        const regions = [...document.querySelectorAll(cartRegions)];
        if (regions.some((region) => region.classList.contains('cart__items--disabled') || [...region.querySelectorAll('input[name="updates[]"]')].some((input) => input.value !== input.getAttribute('value')))) {
          this.showError(this.strings.wait);
          return;
        }
        document.querySelectorAll('jp-cart-herbal-addon, jp-cart-addon-slot').forEach((node) => { node.refreshController?.abort(); node.refreshController = null; });
        const submission = { context: contextOf(this), slot: this.closest('.jp-addon-slot'), regions: new Map(), controls: new Map(), cartChanged: false, events: ['click', 'keydown', 'input', 'change', 'submit'] };
        submission.blockInteraction = (interaction) => {
          const target = interaction.target;
          if (target.closest?.(cartRegions + ', ' + checkoutControls + ', jp-cart-herbal-addon form') || (interaction.type === 'submit' && ['main-cart-items', 'CartDrawer-CartItems'].some((id) => target.contains?.(document.getElementById(id))))) {
            interaction.preventDefault();
            interaction.stopImmediatePropagation();
          }
        };
        activeSubmission = submission;
        submission.events.forEach((name) => document.addEventListener(name, submission.blockInteraction, true));
        submission.observer = new MutationObserver(lockCartControls);
        submission.observer.observe(document.body, { childList: true, subtree: true });
        lockCartControls();
        this.pending = true;
        const button = this.form.querySelector('button');
        const label = button.textContent;
        button.disabled = true;
        button.textContent = this.strings.adding;
        this.setAttribute('aria-busy', 'true');
        this.querySelector('.jp-cart-addon__error').hidden = true;
        this.querySelector('.jp-cart-addon__refresh').hidden = true;
        let sent = false;
        let uncertain = false;
        try {
          const cart = await this.readCart();
          if (this.hasAddon(cart)) {
            this.applySections(await this.fetchSections(), true);
            return;
          }
          if (this.isEligible(cart) !== (this.dataset.eligible === 'true')) {
            this.applySections(await this.fetchSections());
            const current = findCard(submission.context);
            if (current) {
              const notice = current.querySelector('.jp-cart-addon__notice');
              notice.textContent = current.strings.changed;
              notice.hidden = false;
              current.querySelector('button')?.focus({ preventScroll: true });
            }
            return;
          }
          sent = true;
          const response = await fetch(this.dataset.addUrl + '.js', {
            method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(this.dataset.variantId), quantity: 1 }], sections: this.getSections(), sections_url: window.location.pathname })
          });
          const result = await response.json();
          if (!response.ok || result.status) {
            sent = false;
            throw new Error(result.description || this.strings.error);
          }
          this.applySections(submission.cartChanged ? await this.fetchSections() : result.sections, true);
        } catch (error) {
          if (sent) {
            try {
              if (this.hasAddon(await this.readCart())) {
                this.applySections(await this.fetchSections(), true);
                return;
              }
            } catch (reconcileError) {
              uncertain = true;
            }
          }
          const current = this.isConnected ? this : findCard(submission.context);
          current?.showError(uncertain ? this.strings.uncertain : error.message || this.strings.error, uncertain);
        } finally {
          if (uncertain) { uncertainVariant = this.dataset.variantId; uncertainContext = submission.context; }
          releaseCartControls(submission);
          this.pending = false;
          if (button.isConnected) {
            button.disabled = uncertain || submission.controls.get(button)?.disabled;
            button.textContent = label;
          }
          if (uncertainVariant) blockUncertainCards();
          const drawer = document.querySelector('cart-drawer');
          if (submission.context === 'drawer' && drawer?.classList.contains('active') && typeof trapFocus === 'function') {
            const current = findCard('drawer');
            const focus = current?.querySelector('.jp-cart-addon__manage') || current?.querySelector('button:not(:disabled)') || drawer.querySelector('.drawer-close');
            trapFocus(drawer.querySelector('.drawer-inner'), focus);
          }
          this.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jp-responsive-feather-proof"] && !Shopify.designMode) return;
  try {
    const initializeResponsiveFeatherProof = (root) => {
    if (!root || root.dataset.jpFeatherCompareReady === 'true') return;

    const slider = root.querySelector('[data-jp-feather-slider]');
    const range = root.querySelector('.jpr-ad-feather-range');
    if (!slider || !range) return;

    const updatePosition = () => {
      slider.style.setProperty('--jp-feather-position', `${range.value}%`);
      range.setAttribute('aria-valuetext', `${range.value}% reveal`);
    };

    range.addEventListener('input', updatePosition);
    updatePosition();
    root.dataset.jpFeatherCompareReady = 'true';
  };

  document.querySelectorAll('[data-jp-feather-compare]').forEach(initializeResponsiveFeatherProof);

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-jp-feather-compare]');
    if (root) initializeResponsiveFeatherProof(root);
  });
  } catch(e) { console.error(e); }
})();

})();
